/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Published_AtInputs */

const cs_order_published_at = /** @type {(inputs: Order_Published_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum publikace`)
};

const en_order_published_at = /** @type {(inputs: Order_Published_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published at`)
};

/**
* | output |
* | --- |
* | "Published at" |
*
* @param {Order_Published_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_published_at = /** @type {((inputs?: Order_Published_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Published_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_published_at(inputs)
	return cs_order_published_at(inputs)
});